function textFormat(r) {
    return `/${r}/`;
}

export const feedback = {
    '200_POST': ' created successfully',
    '200_PUT': ' edited successfully',
    '200_DELETE': ' deleted successfully',
    '200_CLONE': ' cloned successfully',
    '200_UPLOAD': ' uploaded successfully',
    '200_Submit': ' submitted successfully',
    '200_Approve': ' approved successfully',
    '200_Consolidate': ' consolidated successfully',
    '200_RejectConsolidate': ' rejected consolidate successfully',
    '200_Reject': ' rejected successfully ',
    '200_Close': ' closed successfully',
    '200_Open': ' opened successfully',

    '400_ERROR': 'Entity data fields are invalid ',
    '401_ERROR': 'Authentication Failed',
    '403_ERROR': 'You are not authorized to perform this operation',
    '404_ERROR': 'Not exists ',
    '404_DELETE': 'An error occurred while deleting the entity ',
    '404_PUT': 'An error occurred while editing the entity ',
    '409_ERROR': 'User is already exists into database',

    '500_POST': 'Error while creating the ',
    '500_PUT': 'Error while editing the ',
    '500_DELETE': 'Error while deleting the ',
    '500_ERROR': 'An error occurred while retrieving ',
    '500_UPLOAD': 'An error occurred while uploading ',

    '501_POST': 'Error while creating the ',
    '501_GET': 'Error while retrieving the ',
    '501_PUT': 'Error while editing the ',
    '501_DELETE': 'Error while deleting the ',
    '501_ERROR': 'An error occurred while retrieving ',
    '501_UPLOAD': 'An error occurred while uploading ',
    '501_DOWNLOAD': 'An error occurred while downloading ',
    '503_GET': 'Something has gone wrong, cannot access to requested page. Seems you are offline and you never accessed this resource before, or you are offline and this resource is not available in offline mode',
};

export const getError = (error, entity, operation) => {
    let result = null;
    if (error.response) {
        const { status } = error.response;
        const message = error.response.data || '';
        if (error.response.status === 400 && (operation === 'POST' || operation === 'PUT')) {
            result = `${feedback[`400_${operation}`] + entity} (${status})`;
        }
        if (error.response.status === 400 && !(operation === 'POST' || operation === 'PUT')) {
            result = `${feedback['400_ERROR']}(${status})`;
        }
        if (error.response.status === 404 && operation !== 'DELETE' && operation !== 'PUT') {
            result = `${feedback['404_ERROR'] + entity} (${status})`;
        }
        if (error.response.status === 404 && (operation === 'DELETE' || operation === 'PUT')) {
            result = error.response.data || `${feedback[`404_${operation}`]} (${status}) `;
        }
        if (error.response.status === 500) {
            result = `${feedback[`500_${operation}`] + entity} (${status})`;
        }
        if (error.response.status === 500 && operation !== 'PUT') {
            result = `${feedback['500_ERROR'] + entity} (${status})`;
        }
        if (error.response.status === 409) {
            result = `${feedback['409_ERROR']} (${status})`;
        }
        if (error.response.status === 403) {
            result = `${feedback['403_ERROR']} (${status})`;
        }
        if (error.response.status === 401) {
            result = `${feedback['401_ERROR']} (${status})`;
        }
        if (error.response.status === 501) {
            result = `${feedback[`501_${operation}`] + entity} (${status})`;
        }
        if (error.response.status === 500) {
            result = `${feedback[`500_${operation}`] + entity} (${status})`;
        }
        if (error.response.status === 409 && message === 'UniqueException') {
            result = `Duplicates are not allowed (${status})`;
        }
        if (error.response.status === 409 && operation === 'DELETE') {
            result = `Unable to delete ${entity} because associated with an entity (${status})`;
        }
        if (error.response.status === 501 && message === 'Wrong Approver') {
            result = `Wrong Approver (${status})`;
        }
        if (error.response.status === 503 && operation === 'GET') {
            result = `${feedback[`503_${operation}`]}`;
        }
        if (operation === 'DOWNLOAD') {
            result = `File operation error (${status})`;
        }
        if (error.response.status === 439) {
            result = message;
        }
    } else if (error.message) {
        result = error.message;
    } else {
        result = error;
    }

    return result;
};

export const getSuccess = (entity, operation) => {
    let result = null;
    result = (entity === undefined ? '' : entity) + feedback[`200_${operation}`];
    return result;
};

export const errors = {
    401: 'Forbidden',
};

export const entities = {
    TODO: 'todos',
    DYNAMIC_CRUD: 'admin',
    TASKS: 'tasks',
    HOCCARD: 'hoccard',
    ME: 'me',
    REGISTRY: 'registry',
    INCIDENT: 'incident',
    TRAINING: 'training',
    ACTIVITYLOG: 'activitylog',
    INSPECTION: 'inspection',
    DRILL: 'drill',
    AUDIT: 'audit',
    KPI: 'kpi',
};

export const entitiesLabels = {
    EXPORTAUDITS: 'Audits Export',
    EXPORTFINDINGS: 'Findings Export',
    CARTEMPLATE: 'CAR Template',
    TRAININGPARTICIPANTTEMPLATE: 'Training Participant Template',
    HOCCARDTEMPLATE: 'HOC Template',
    HOCCARD: 'HOC',
    HOCCARDSOURCES: 'HOC Sources',
    HOCCARDSAVAILABLEYEARS: 'HOC filter available years',
    HOCCARD_ATTACHMENTS_AVAILABILITY: 'HOC Attachment Availability',
    WORKSITE: 'Worksite',
    HOCTYPE: 'Hoctype',
    HAZARDTYPE: 'Hazard Type',
    HOCPRIORITY: 'Hoc Priority',
    LIFESAVINGRULEVIOLATION: 'Life Saving Rule Violation',
    TYOPLOGY: 'Typology', //RITM1143712
    INFOORIGINATOR: 'HOC raised by',
    YEAR: 'Year',
    PROJECT: 'Project',
    USER: 'Users',
    APPMODULE: 'App Module',
    ROLE: 'Role',
    // DIVISION: 'Division',
    DIVISION: 'Business Line', //RITM0945977
    // MAINDIVISION: 'Main Division', //RITM0945977
    MAINDIVISION: 'Main Business Line',
    COUNTRY: 'Country',
    // SUBDIVISION: 'Sub Division', //RITM0945977
    SUBDIVISION: 'Sub-Business Line',
    COMPANY: 'Company',
    ACTIVITY: 'Activity',
    WORKSITEPROJECT: 'Worksite Project',
    WORKSITEPROJECT_QRCODE: 'Worksite Project QR Code',
    WORKSITEGROUP: 'WorkSite GROUP',
    STATUS: 'Status',
    INCIDENT: 'Incident',
    DOCUMENTS: 'Documents',
    INCIDENT_NOTIFICATION: 'Incident Notification',
    INCIDENT_REPORT: 'Incident Report',
    BODYPART: 'Body Part',
    INJURYCLASS: 'Injury Class',
    INJURYSOURCE: 'Injury Source',
    INJURYTYPE: 'Injury Type',
    CONTRACTTYPE: 'Contract Type',
    SHIFDURATION: 'Shif Duration',
    JOBPOSITION: 'Job Position', //RITM0946148
    HIGHCONSEQUENCE: 'High Consequence', //RITM1147493
    EFFECTIVEBARRIERGROUP: 'Effective Barrier Group', //RITM1147493
    INADEQUATEBARRIERGROUP: 'Inadequate Barrier Group', //RITM1147493
    EFFECTIVEBARRIER: 'Inadequate Barrier', //RITM1147493
    INADEQUATEBARRIER: 'Inadequate Barrier', //RITM1147493
    BARRIERGROUP: 'Barrier Group', //RITM1230723
    BARRIER: 'Barrier', //RITM1230723
    REALPOTENTIALCONSEQUENCE: 'Real Potential Consequence', //RITM1405215
    REPORTBARRIERKPIINPUT: 'Report Barrier KPI',
    ACCIDENTSOURCE: 'Accident Source',
    SEVERITY: 'Severity',
    MEASUREUNIT: 'Measure Unit',
    WORKPROCESS: 'Work Process',
    PROBABILITY: 'Probability',
    WORKAREA: 'Work Area',
    EQUIPMENT: 'Equipment',
    ATTACHMENT: 'Attachment',
    INSPECTION: 'Inspection',
    INPSECTOR: 'Inspector',
    DIRECTCAUSE: 'Direct Cause ',
    DIRECTCAUSEDETAIL: 'Direct Cause Detail',
    ROOTCAUSE: 'Root Cause',
    ROOTCAUSEDETAIL: 'Root Cause Detail',
    ROOTCAUSESUBDETAIL: 'Root Cause Sub Detail',
    EMPLOYER: 'Employer',
    ENVIROMENT: 'Enviroment',
    REPORTSUMMARY: 'Report Summary',
    LEASEDASSET: 'Leased Asset',
    DISCIPLINE: 'Discipline',
    SUBCONTRACTOR: 'Sub Contractor',
    REPORT: 'Report',
    TASK: 'Task',
    CAR: 'Car',
    CA: 'CA',
    FINDING: 'Finding',
    SECTION: 'Section',
    SCOPE: 'Scope',
    TYPEAUDIT: 'Type of Audit',
    AUDITOR: 'Auditor',
    INJUREDPEROSN: 'Injured Person',
    TARGET: 'Target',
    AUDIT: 'Audit',
    AUDIT_REPORT: 'Audit report',
    AUDIT_PLAN: 'Audit plan',
    AUDIT_NOTIFICATION: 'Audit notification',
    AUDITCHECKLIST_TEMPLATE: 'Audit CheckList Template',
    AUDIT_FINDING: 'Audit finding',
    ENTITY: 'Entity',
    TEAMMEMBER: 'Team Member',
    WITNESSPEOPLE: 'Witness Peolple',
    NOTIFICATION: 'Notification',
    AuditNCClassificationType: 'Classification Type',
    PLACE: 'Place',
    WORKRELATED: 'WorkRelated',
    TRANSPORTACCIDENT: 'TransportAccident',
    PUBLICAUTHORITIES: 'PublicAuthoritiesAndEntitiesInvolved',
    HISTORYWF: 'History',
    ACTIVITYLOG: 'Activity Log',
    EMERGENCYDRILL: 'Emergency Drill',
    EMERGENCYDRILL_CAR: 'Emergency Drill CAR',
    EMERGENCYDRILL_REQ: 'Emergency Drill Requiremnt',
    EMERGENCYDRILL_NOTIFICATION: 'Emergency Drill Notification',
    EMERGENCYDRILL_REPORT: 'Emergency Drill Report',
    EMERGENCYDRILL_ANNUALPLAN: 'Annual Drill Plan Document',
    EMERGENCYDRILL_PLANNEDWEEKCHANGES: 'Emergency Drill Planned Week Changes',
    EMERGENCYDRILL_WORKSITEATTACHMENT: 'Emergency Drill Worksite related Documentation',
    EMERGENCYDRILL_PERSON: 'Emergency Drill Personnel', //RITM1535076
    EMERGENCYDRILL_PERSONNELTEMPLATE: 'Drill Participants Template', //RITM1535076
    FREQUENCY: 'Frequency',
    PLANNEDWEEK: 'Planned Week',
    REQUIREMENT: 'Requirement',
    INSPECTION_NOTIFICATION: 'Inspection Notification',
    INSPECTION_REPORT: 'Inspection Report',
    SEACONDITIONS: 'Sea Conditions',
    LIGHTCONDITIONS: 'Light Conditions',
    WEATHERCONDITIONS: 'Weather Conditions',
    TRAINING: 'Training',
    TRAININGDATA: 'Training Data',
    TRAININGLANGUAGE: 'Training Language',
    TRAININGLOCATION: 'Training Location',
    TRAININGMETHOD: 'Training Method',
    TRAININGASSESSMENTMETHOD: 'Training Assessment Method',
    TRAININGCENTER: 'Training Center',
    TRAININGPARTICIPANT: 'Training Participant',
    TRAINER: 'Trainer',
    TRAININGCERTIFICATE: 'Training Certificate',
    KPIMANUALINPUT: 'Kpi Manual Input',
    INFO: 'Information',
    SUCCESS: 'Well Done!',
    SYNC: 'Synching',
    ERROR: 'Error!',
    WARNING: 'Warning!',
    WITHCODE: 'with Code:',
    REASONFORSAMPLING: 'Reason For Sampling',
    GENERICOWNER: 'Generic owner',
    EIGHTMEGABYTEMAXSIZE: '8MB  max file size',
    SELECTNEWFILE: 'Please select a new file and try again',
    MBAVAILABLE: 'MB available',
    MAXSUMIMAGESIZE: 'The sum of images size must be 3MB or less',
    THREEMEGABYTEMAXSIZE: '3MB max file size',
    TENMEGABYTEMAXSIZE: '10MB max file size',
    /*NF ID: RITM1216061 || Task - 4 || Sub-Task-1 || Vanitha ,Chiranjeevi */
    DISTRIBUTIONLIST: 'Distribution List',

  // #region RITM0646764 Estrazione Massiva Audit
  AUDITMASSIVEEXTRACTION_GETCOUNTRIESBUSINESSLINES: 'Get Countries and Business Lines',
  AUDITMASSIVEEXTRACTION_GETAUDITS: 'Get Audits',
  // #endregion
  PURCHASEORDERS: 'Purchase Orders', // RITM0646764
  EMERGENCYLEVEL: 'Emergency levels',
  //RITM0958089 & RITM0963328 - Drill Year Filter Fix
  DRILLSAVAILABLEYEARS: 'Emergency Drill filter available years', 
  //End 
  CUSTOMLINKS: 'Custom link for PBI',//RITM1243695
};

export const apioperation = {
    POST: 'POST',
    UPLOAD: 'UPLOAD',
    DELETE: 'DELETE',
    PUT: 'PUT',
    DOWNLOAD: 'DOWNLOAD',
    GET: 'GET',
};

export const API = {
    TODOS: textFormat(entities.TODOS),
    TASKS: textFormat(entities.TASKS),
    DYNAMIC_CRUD: textFormat(entities.DYNAMIC_CRUD),
    HOCCARD: textFormat(entities.HOCCARD),
    ME: textFormat(entities.ME),
    TRAINING: textFormat(entities.TRAINING),
    REGISTRY: textFormat(entities.REGISTRY),
    INCIDENT: textFormat(entities.INCIDENT),
    INSPECTION: textFormat(entities.INSPECTION),
    ACTIVITYLOG: textFormat(entities.ACTIVITYLOG),
    DRILL: textFormat(entities.DRILL),
    KPI: textFormat(entities.KPI),
    KPIMI: textFormat(`${entities.KPI}/manual-input`),
    KPIHSE: textFormat(`${entities.KPI}/hse`),
    AUDIT: textFormat(entities.AUDIT),
};

export const ENUM_RoleEntity = {
    None: 0,
    Worksites: 1,
    Division: 2,
};

export const ENUM_RoleCode = {
    Compiler: 1,
    DataApprover: 2,
    DivisionManager: 3,
    Administrator: 4,
};

export const STATUS = {
    Draft: 1,
    Submitted: 2,
    Approved: 3,
    Consolidated: 4,
};

export const FindingSTATUS = {
    Draft: 1,
    Assigned: 2,
    Submitted: 3,
    Open: 4,
    Closed: 5,
    Completed: 6
};
// export const DateFormat = 'DD-MM-YYYY';
// formato data e ora per Front End
export const DateFormat = 'DD/MM/YYYY';
export const TimeFormat = 'hh:mm A';

// formato data e ora per Back End
export const BEDateFormat = 'YYYY-MM-DD';
export const BETimeFormat = 'hh:mm A';

export const TaskCategory = {
    CATEGORY_APPROVAL: 'Approval',
    CATEGORY_COMPILATION: 'Compilation',
};
export const NotificationModule = {
    ModuleAudit: 'Audit',
    ModuleReport: 'Report',
    ModuleIncident: 'Incident',
    ModuleHocCards: 'Hoc Card',
    ModuleInspection: 'Inspection',
    ModuleTraining: 'Training',
    ModuleDrill: 'Drill',
};

export const LogOperation = {
    OPERATION_LOG_UPDATE: 'UPDATE',
    OPERATION_LOG_DELETE: 'DELETE',
    OPERATION_LOG_INSERT: 'INSERT',
};
export const LogModule = {
    MODULE_LOG_INCIDENT: 'Incident',
    MODULE_LOG_AUDIT: 'Audit',
    MODULE_LOG_REPORT: 'Report',
    MODULE_LOG_BACKOFFICE: 'Back Office',
    MODULE_LOG_HOCCARD: 'HOC Card',
};

export function sizeFormat(bytes, precision) {
    if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '-';
    if (typeof precision === 'undefined') precision = 1;
    const units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'];
    const number = Math.floor(Math.log(bytes) / Math.log(1024));

    if (bytes === '0') return '0 bytes';

    return `${(bytes / Math.pow(1024, Math.floor(number))).toFixed(precision)} ${units[number]}`;
}

export const CarType = {
    NC: { Code: 1, ShortName: 'NC', Name: 'Non Conformity' },
    OBS: { Code: 2, ShortName: 'OBS', Name: 'Observation' },
    SFI: { Code: 3, ShortName: 'SFI', Name: 'Suggestion For Improvement' },
    Strength: { Code: 4, ShortName: 'STR', Name: 'Strength' },
};

export function GetCarTypeByCode(code) {
    switch (code) {
        case 1:
            return CarType.NC;
        case 2:
            return CarType.OBS;
        case 3:
            return CarType.SFI;
        case 4:
            return CarType.Strength;
        default:
            return CarType.NC;
    }
}

export const AuditSection = {
    QUALITY: { id: 'C3A92266-C9A0-4776-BD60-7A91233BFA5F', name: 'Quality Section' },
    HSE: { id: '922E131F-2AD1-4536-8F41-9AAE128F4927', name: 'HSE Section' },
    HSEQ: { id: '8191ACFE-D277-4ED5-ABB2-33AD1FEE1588', name: 'HSEQ Section' }
};

export const TEAM_LEADER = 'Team Leader - Lead Auditor';
export const Megabyte = {
    ONEMEGABYTE: 1048576,
    THREEMEGABYTE: 3145728,
    FOURMEGABYTE: 4194304,
    TENMEGABYTE: 10485760,
};

export const PlannedWeekChangeType = {
    ToAdd: 1,
    ToChange: 2,
    ToDelete: 3
};
